var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":"red lighten-5 red--text","type":"warning","dark":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t('main.item_deleted_warning')))]),_c('h6',[_vm._v(_vm._s(_vm.$t('main.item_deleted_warning_info')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }